import { render, staticRenderFns } from "./Authentication.vue?vue&type=template&id=72f2340a&scoped=true&"
import script from "./Authentication.vue?vue&type=script&lang=js&"
export * from "./Authentication.vue?vue&type=script&lang=js&"
import style0 from "./Authentication.vue?vue&type=style&index=0&id=72f2340a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f2340a",
  null
  
)

export default component.exports